export default __webpack_public_path__ + "static/media/mac.1bd91648.png";